import { debuggerResponse } from "../utils/Debugger";

export function searchResponse(
  path,
  method = "GET",
  myHeaders = new Headers(),
  myBody = null
) {
  // TODO confirmar se não dá erro no body vazio
  let myInit = {
    method: method,
    headers: myHeaders,
    mode: "cors",
    body: myBody ? JSON.stringify(myBody) : myBody,
    "Content-Type": "application/json",
    Accept: "application/json",
    // cache: "default",
  };

  return fetch(path, myInit);
}

// Foi o primeiro a ser criado, por isso está com o nome de search.
// Não foi mudado para searchJSON para não dar erro nos métodos que já utilizam
export function search(
  path,
  method = "GET",
  myHeaders = new Headers(),
  myBody = null
) {
  if (!sessionStorage.getItem("empresa_cnpj"))
    return { seccess: false, message: "empresa_cnpj é obrigatório." };

  return searchResponse(path, method, myHeaders, myBody)
    .then((response) => {
      const promisse = response.json();
      debuggerResponse(promisse);
      return promisse;
    })
    .catch((error) => {
      console.error(error);

      return { success: false, mensagem: error };
    });
}

export function searchText(
  path,
  method = "GET",
  myHeaders = new Headers(),
  myBody = null
) {
  return searchResponse(path, method, myHeaders, myBody)
    .then((response) => {
      return response.text();
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export function searchV3(
  path,
  method = "GET",
  myHeaders = new Headers(),
  myBody = null
) {
  return searchResponse(path, method, myHeaders, myBody)
    .then((response) => {
      const promisse = response.json();
      debuggerResponse(promisse);
      return promisse;
    })
    .catch((error) => {
      console.error(error);

      return { success: false, mensagem: error };
    });
}

export function searchImpostos(
  path,
  method = "GET",
  myHeaders = new Headers(),
  myBody = null
) {
  return searchResponse(path, method, myHeaders, myBody)
    .then((response) => {
      const promisse = response.json();
      debuggerResponse(promisse);
      return promisse;
    })
    .catch((error) => {
      console.error(error);

      return { success: false, mensagem: error };
    });
}
